<template>
  <div class="layout-wrap">
    <PageVisbilityWatcher />
    <PageFocusNotifier />
    <ConstructionMenuComponent :isShow="menuShow" @closeMenu="menuShow = false" />
    <ConfirmJoinConstructionComponent />
    <LicenseUpdateDialog />
    <div class="contents-wrap" :class="{ 'bannerShow': bannerShow }">
      <div class="main-wrap">
        <div class="header-wrap">
          <div class="left-wrap" :class="{ 'fp': isFreePlan }">
            <div v-if="leftHeaderButton === 'menu'" class="menu-button-wrap">
              <button class="menu-button" @click="menuShow = true" data-title="メニュー"></button>
            </div>
            <div v-else class="back-button-wrap">
              <router-link :to="backRoute" data-title="戻る" @click="onBackClick">
                <div class="back-button"></div>
              </router-link>
            </div>
            <div class="network-on-icon" />
            <div class="web-page-reload-wrap"
              v-if="versionChecksStore.webPageRefreshRequired">
              <button class="web-page-reload-button"
                data-title="更新する"
                @click.prevent="webPageReload">
              </button>
            </div>
            <div class="title-wrap">
              <template v-if="title">
                <router-link :to="constructionRoute" data-title="トップに戻る">
                  <div class="header-title-icon" />
                  <div class="header-title">
                    {{ title }}
                  </div>
                </router-link>
              </template>
              <div class="header-title-logo-wrap" v-else>
                <img src="@/assets/icons/logo_white.svg" alt="蔵衛門ロゴ">
              </div>
            </div>
          </div>
          <div class="right-wrap" :class="{ 'fp': isFreePlan }">
            <!-- アップデート通知 -->
            <div class="update-wrap"
                v-if="!isFreePlan">
              <a href="#" class="update-link"
                data-title="お知らせ"
                @click.prevent="onClickUpdateHistoryLink">
              </a>
            </div>
            <!-- ヘルプリンク -->
            <div class="help-wrap">
              <ul>
                <li class="help-items-wrap">
                  <button class="help-button"
                          @click="showHelpMenu = !showHelpMenu"
                          data-title="ヘルプ"></button>
                  <div class="help-menu-layer" :class="{ show: showHelpMenu }">
                    <div class="help-menu-background" @click="showHelpMenu = false"/>
                    <ul class="help-menu">
                      <template v-if="!isFreePlan">
                        <li class="help-item">
                          <a :href="externalLinks.pad_guide.url"
                              rel="noopener"
                              target="_blank"
                              class="item-wrap external-link">
                            <div class="item">
                              蔵衛門クラウド・Pad 操作ガイド
                            </div>
                            <div class="arrow"/>
                          </a>
                        </li>
                        <li class="help-item">
                          <a :href="externalLinks.app_guide.url"
                              rel="noopener"
                              target="_blank"
                              class="item-wrap external-link border-bottom">
                            <div class="item">
                              蔵衛門カメラ 操作ガイド
                            </div>
                            <div class="arrow"/>
                          </a>
                        </li>
                      </template>
                      <li class="help-item">
                        <a :href="externalLinks.faq.url" rel="noopener" target="_blank" class="item-wrap external-link faq">
                          <div class="item">
                            よくある質問
                          </div>
                          <div class="arrow"/>
                        </a>
                      </li>
                      <li class="help-item">
                        <a href="#" class="item-wrap external-link" @click.prevent="onClickSupportLink">
                          <div class="item">
                            お問い合わせ
                          </div>
                          <div class="arrow"/>
                        </a>
                      </li>
                      <li class="help-item" v-if="isDisplayPageVersion">
                        <a href="#" class="item-wrap" @click.prevent="() => {}">
                          <div class="item">
                            {{ versionChecksStore.storedKuraemonCloudWebPageVersion }}
                            <button @click="copyToClipboard(versionChecksStore.storedKuraemonCloudWebPageVersion)">コピペ</button>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
            <!-- アプリ一覧へのリンク -->
            <div class="apps-wrap">
              <router-link :to="{ name: 'KuraemonApps' }" class="apps-link" data-title="アプリのダウンロード">
              </router-link>
            </div>
            <!-- ユーザー情報 -->
            <div class="user-wrap" :class="{ premium: isPremiumPlan }">
              <button class="name" data-title="アカウント情報"
                @click="toAccountSetting"
                :class="isAccountKobitoSession ? ['kobito'] : []"><!--
             -->{{ accountInfo.account_name }}<!--
             -->
                <div class="name-badge" v-if="isExistAccountNotification">
                  <NotificationBadge />
                </div>
              </button>
            </div>
            <div class="talk-wrap">
              <template v-if="headerTalkLinkUrl && !isAccountKobitoSession">
                <!-- トークへのリンク -->
                <a :href="headerTalkLinkUrl" class="talk-link" data-title="トーク">
                  <div class="talk-badge" v-if="talkUnreadResult?.isExistUnread">
                    <NotificationBadge />
                  </div>
                </a>
              </template>
              <div v-else class="talk-link disabled">
                <!-- トークへのリンクなし -->
              </div>
            </div>
          </div>
        </div>
        <div class="default-wrap">
          <router-view />
        </div>
      </div>
      <div v-if="bannerShow" class="banner-wrap" :style="bannerWrapStyle">
        <a :href="bannerLinkUrl" rel="noopener" target="_blank">
          <img :src="bannerImageUrl">
        </a>
        <a v-if="bannerImageUrl2" :href="bannerLinkUrl2" rel="noopener" target="_blank">
          <img :src="bannerImageUrl2">
        </a>
      </div>
    </div>
    <AccountStatusDialog />
    <SelfCallErrorDialog />
    <ToExternalPlanInfoDialog />
    <Loading />
  </div>
</template>

<script lang="ts">
export default {
  name: 'DefaultLayout',
}
</script>

<script setup lang="ts">
  import { ref, computed, onMounted, defineAsyncComponent } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { isPremium, isFree } from '@/utils/kuraemon_plans'
  import LicenseUpdateDialog from '@/components/cloud/account/AccountSetting/LicenseUpdateDialog.vue'
  import { externalLinks } from '@/utils/external_links'
  import { useBackRouteStore } from '@/stores/backRoute'
  import { useHeaderStore } from '@/stores/header'
  import { useBannersStore } from '@/stores/banners';
  import { useConstructionStore } from "@/stores/construction"
  import { useLoginStore } from "@/stores/login"
  import { useSupportStore } from "@/stores/support"
  import { storeToRefs } from 'pinia'
  import { talkLinkUrlFor } from '@/utils/kuraemon'
  import { useTalkStore } from '@/stores/talk'
  import { useVersionChecksStore } from "@/stores/versionChecks"
  import { useLoadingStore } from '@/stores/loading'
  import { useTalkUnread } from '@/components/layout/composables/TalkUnreadComposable';

  const loginStore = useLoginStore()
  const supportStore = useSupportStore()
  const route = useRoute()
  const versionChecksStore = useVersionChecksStore()
  const router = useRouter()
  const loadingStore = useLoadingStore()

  const Loading = defineAsyncComponent(() => import('@/components/ui/Loading.vue'))
  const ConstructionMenuComponent = defineAsyncComponent(() => import('@/components/cloud/construction/ConstructionMenuComponent.vue'))
  const NotificationBadge = defineAsyncComponent(() => import('@/components/ui/NotificationBadge.vue'))
  const ConfirmJoinConstructionComponent = defineAsyncComponent(() => import("@/components/cloud/construction/ConfirmJoinConstructionComponent.vue"))
  const ToExternalPlanInfoDialog = defineAsyncComponent(() => import('@/components/cloud/notification/ToExternalPlanInfoDialog.vue'))
  const PageVisbilityWatcher = defineAsyncComponent(() => import("@/components/ui/PageVisbilityWatcher.vue"))
  const PageFocusNotifier = defineAsyncComponent(() => import("@/components/ui/PageFocusNotifier.vue"))
  const AccountStatusDialog = defineAsyncComponent(() => import("@/components/cloud/denwa/AccountStatusDialog.vue"))
  const SelfCallErrorDialog = defineAsyncComponent(() => import("@/components/cloud/denwa/SelfCallErrorDialog.vue"))

  const menuShow = ref(false)
  const showHelpMenu = ref(false)
  const s3ConstructionsPollingId = ref<number>()

  // Talk Unread Composable
  const { talkUnreadResult } = useTalkUnread()
  
  const backRouteStore = useBackRouteStore()
  const { backRoute } = storeToRefs( backRouteStore )

  const onBackClick = () => {
    backRouteStore.onBackButtonClick?.()
  }

  const {
    title,
    leftHeaderButton,
    isExistAccountNotification,
  } = storeToRefs(useHeaderStore())

  const {
    talkLinkUrl,
    returnKcloudPath,
  } = storeToRefs(useTalkStore())

  const headerTalkLinkUrl = computed<string>(() => {
    return talkLinkUrlFor(talkLinkUrl.value, returnKcloudPath.value)
  })

  const accountInfo = computed(() => {
    // TODO storesからとる
    return loginStore.currentAccount
  })
  const isAccountKobitoSession = computed(() => {
    return "session_type" in accountInfo.value && "kobito" in accountInfo.value.session_type
  })

  const toAccountSetting = async () => {
    await loadingStore.loadingProc(async () => {
      await router.push({ name: 'AccountSetting' })
    })
  }

  const constructionRoute = computed(() => {
    const constructionListRoute = { name: 'ConstructionList' }
    if (route.params.cloudConstructionId) {
      return {
        ...constructionListRoute,
        query: {
          construction_id: route.params.cloudConstructionId as string
        }
      }
    }
    return constructionListRoute
  })

  const isPremiumPlan = computed(() => {
    return isPremium(accountInfo.value.service_contract_type);
  })

  const isFreePlan = computed(() => {
    return isFree(accountInfo.value.service_contract_type);
  })

  // (テスト用) ヘルプにバージョンを表示するかどうか
  const isDisplayPageVersion = computed(() => (import.meta.env.VITE_APP_ENV_NAME !== "prod"))

  const {
    bannerImageUrl,
    bannerLinkUrl,
    bannerImageUrl2,
    bannerLinkUrl2,
    backgroundColorCode,
  } = storeToRefs(useBannersStore())
  const bannerShow = computed(() => {
    return route.meta.isBannerDisplay && bannerImageUrl.value;
  })
  const bannerWrapStyle = computed(() => {
    if (backgroundColorCode.value) {
      return { backgroundColor: backgroundColorCode.value }
    }
    return {}
  })
  onMounted(() => {
    updateS3Construction();
  })
  // methods
  // s3接続情報の更新（定期処理）
  const updateS3Construction = () => {
    const constructionStore = useConstructionStore()

    if(route.params.cloudConstructionId){
      const args = {
        cloud_construction_id: route.params.cloudConstructionId as string,
        __apiOptions: { noDisplayLoading: true, noStore: true, noErrorDialog: true }
      }
      constructionStore.getCloudConstruction(args)
    }
    
    // タイマーを設定（30分）
    s3ConstructionsPollingId.value = window.setTimeout(updateS3Construction, 1000*60*30 );
  }
  const onClickSupportLink = async () => {
    const url = await supportStore.getSupportUrl({ __apiOptions: { noErrorDialog: true } })
    
    window.open(url, "_blank", "noopener")
  }
  const onClickUpdateHistoryLink = async () => {
    // アップデート一覧へのリンク
    const url = 
      await supportStore.getSupportUrl({ __apiOptions: { noErrorDialog: true }, url_type: 'updateHistory' })
    
    window.open(url, "_blank", "noopener")
  }
  const webPageReload = () => {
    window.location.reload()
  }

  function copyToClipboard(text: string | undefined) {
    if(!text) return
    navigator.clipboard.writeText(text)
  }
</script>
<style lang="scss" scoped>
a {
  color: white;
}

.layout-wrap {
  height: 100%;

  .contents-wrap {
    height: 100%;

    .main-wrap {
      height: 100%;
    }

    &.bannerShow {
      .main-wrap {
        // バナーとメインコンテンツを横並びにする
        display: inline-block;
        vertical-align: top;
        width: calc(100% - 240px);

        .header-wrap {
          width: calc(100% - 240px); // fixed要素なので別途指定
        }
      }

      .banner-wrap {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        // はみ出した際に上端が切れて見えなくなるのを防ぐ(未対応ブラウザでは通常のcenterのまま)
        justify-content: safe center;
        gap: 8px;
        vertical-align: top;
        width: 240px;
        height: 100%;
        padding: 30px 0;
        overflow-y: auto; // 2枚分ではみ出す場合はスクロールさせる

        a {
          width: 100%;
          text-align: center;
          transition: opacity 0.2s;

          &:hover {
            opacity: 0.8;
          }

          & img {
            width: 100%;
            height: auto;
            vertical-align: middle; // imgの下にできる余白を消す
          }
        }
      }

      @media screen and (max-width: 740px) {

        // 500px + バナー幅240px
        // バナー非表示にする
        .main-wrap {
          display: block;
          width: 100%;

          .header-wrap {
            width: 100%;
          }
        }

        .banner-wrap {
          display: none;
        }
      }
    }
  }
}

/** ヘッダー */
.header-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
}

.header-wrap>div,
.left-wrap>div,
.right-wrap>div {
  height: 50px;
}

.header-wrap {
  display: flex;
  flex-wrap: nowrap; // 1段に収める
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 38;
  background-color: #1A2274;
  color: #FFF;
  // ツールチップ
  div[data-title]:hover::after,
  a[data-title]:hover::after,
  button[data-title]:hover::after {
    // hoverのとき表示
    visibility: visible;
  }
  div[data-title]::after,
  a[data-title]::after,
  button[data-title]::after {
    // data-title属性の値を内容として使用
    content: attr(data-title);
    // 親要素の下に配置
    position: absolute;
    top: calc(100% + 3px);
    // 折り返さない
    white-space: nowrap;
    background-color: #FFF;
    color: #000;
    border: solid 1px #6D6D6D;
    border-radius: 3px;
    font-size: 0.85rem;
    margin: 0 auto;
    padding: 0.2rem 0.8rem 0.15rem 0.8rem;
    line-height: 1.5;
    // デフォルトでは非表示
    visibility: hidden;
  }
  .menu-button[data-title]::after {
    // 左寄せ
    left: 0;
  }
  .talk-link[data-title]::after {
    // 右寄せ
    right: 0;
  }
  .update-wrap a[data-title]::after,
  .help-wrap button[data-title]::after,
  .web-page-reload-wrap button[data-title]::after,
  .title-wrap a[data-title]::after,
  .help-wrap button[data-title]::after,
  .apps-link[data-title]::after,
  .user-wrap .name[data-title]::after {
    // 中央配置
    left: 50%;
    transform: translateX(-50%);
  }
}

/** 左 */
.left-wrap {
  flex-grow: 1; // .rignt-wrap以外の領域を占有
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  min-width: 0;
}

/** 右 アップデート通知50px ヘルプボタン50px アプリボタン50px トークボタン50px 名前最大120px */
.right-wrap {
  flex-grow: 0; // 伸びない
  flex-shrink: 0; // 縮まない
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
}

/** メニューボタン 50px */
.menu-button-wrap .menu-button {
  width: 50px;
  height: 50px;
  border: none;
  background: url("@/assets/icons/hamburger.svg") no-repeat center center;
  cursor: pointer;
  position: relative;
}

/** 戻るボタン 50px */
.back-button-wrap {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 50px;
}
.back-button-wrap .back-button {
  width: 50px;
  height: 50px;
  border: none;
  background: #FFF url("@/assets/icons/arrow_back_blue.svg") no-repeat center center;
  cursor: pointer;
}

/** ON/OFF アイコン 83px */
.network-on-icon,
.network-off-icon {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 83px;
  border: none;
}

.network-on-icon {
  background: url("@/assets/icons/on_icon.svg") no-repeat center center;
  background-size: 38px;
}

.network-off-icon {
  background: url("@/assets/icons/off_icon.svg") no-repeat center;
  background-size: 38px;
}

.web-page-reload-wrap {
  // バージョンアップ(更新)を促すボタン
  flex-basis: 220px;
  flex-grow: 0;
  flex-shrink: 1; // 幅が狭い場合縮ませる
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .web-page-reload-button {
    border: none;
    background: url("@/assets/icons/update_alert.svg") no-repeat center center;
    background-size: contain;
    width: 100%;
    max-width: 216px;
    height: 32px;
    padding: 0;
    cursor: pointer;
  }
}

/** 工事 100% - (50 + 83)px */
.title-wrap {
  flex-basis: auto;
  flex-grow: 1; // 幅に余裕があれば伸びる
  flex-shrink: 1; // 幅が狭い場合縮ませる
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  min-width: 0;
}

.title-wrap .header-title-icon {
  // 工事名横のアイコン
  flex-basis: 22px;
  flex-grow: 0; // 伸びない
  flex-shrink: 0; // 縮まない
  height: 36px;
  border: none;
  background: transparent url("@/assets/icons/house_white.svg") no-repeat center center;
  background-size: contain;
}

.title-wrap a {
  display: flex;
  flex-wrap: nowrap;
  align-items: end;
  justify-content: center;
  text-decoration: none;
  min-width: 0;
  flex-basis: 100%;
}

.title-wrap .header-title {
  flex-basis: auto;
  flex-grow: 0;
  flex-shrink: 1;
  font-size: 1.5rem;
  padding: 0 1rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.header-title-logo-wrap {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

.header-title-logo-wrap>img {
  // 最大高さ30pxまでで、大きさは幅によって決める
  width: 100%;
  height: auto;
  max-height: 30px;
}

// アップデート通知
.update-wrap {
  border-left: solid 2px rgba(255, 255, 255, 0.5);
  text-align: center;
  width: 50px;
  position: relative;
  .update-link {
    display: block;
    height: 100%;
    width: 100%;
    background: url('@/assets/icons/bell_white.svg') center center no-repeat;
    cursor: pointer;
    text-decoration: none;
    position: relative
  }
}

// ヘルプ
.help-wrap {
  border-left: solid 2px rgba(255, 255, 255, 0.5);
  text-align: center;
  width: 50px;
  position: relative;
  > ul {
    list-style: none;
    padding: 0;
    margin: 0;
    height: 100%;
  }
  .help-items-wrap {
    height: 100%;
    .help-button {
      position: relative;
      width: 100%;
      height: 100%;
      border: none;
      background: url('@/assets/icons/question_circle_white_back_transparent.svg') center center no-repeat;
      cursor: pointer;
      padding: 0;
      z-index: 2;
    }
    .help-menu-layer {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      display: none;
      &.show {
        display: block;
      }
      .help-menu-background {
        position: fixed;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background-color: transparent;
        z-index: 1;
      }
      .help-menu {
        z-index: 1;
        list-style: none;
        font-size: 1rem;
        padding: 0;
        margin: 0;
        position: absolute;
        width: auto;
        min-width: 170px;
        white-space: nowrap; // 折り返さない
        right: -2px;
        top: 100%;
        background-color: #FFF;
        text-align: left;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        overflow: hidden;
        box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
        .help-item {
          position: relative;
          cursor: pointer;
          padding: 10px 40px 10px 10px; // 矢印のぶん右広め
          &:nth-of-type(n+2) {
            border-top: 1px solid #E1E1E1;
          }
          a {
            color: #000;
            text-decoration: none;
          }
          .arrow {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 10px;
            width: 20px;
            height: 20px;
            background: url('@/assets/icons/arrow_gray.svg') center center no-repeat;
            background-size: contain;
          }
          &:hover {
            background-color: #C8D7F2;
            .arrow {
              background: url('@/assets/icons/arrow_forward_blue.svg') center center no-repeat;
              background-size: contain;
            }
          }
        }
      }
    }
  }
}

/** アプリ */
.apps-wrap {
  border-left: solid 2px rgba(255, 255, 255, 0.5);
  text-align: center;
  width: 50px;
  position: relative;
}

.apps-wrap .apps-link {
  display: block;
  height: 100%;
  width: 100%;
  background: url('@/assets/icons/nine_squares.svg') center center no-repeat;
  cursor: pointer;
  text-decoration: none;
  position: relative
}

/** ユーザー 120px */
.user-wrap {
  border-left: solid 2px rgba(255, 255, 255, 0.5);
  text-align: center;
  max-width: 120px;
  position: relative;
}

.user-wrap .name {
  border: none;
  background-color: transparent;
  text-decoration: none;
  color: white;
  display: inline-block;
  vertical-align: middle;
  line-height: 50px;
  padding: 0 1rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 120px;
  cursor: pointer;
}

.user-wrap .name.kobito {
  color: orange;
}

/** 有料ユーザー */
.user-wrap.premium .name {
  background: url('@/assets/icons/premium_icon.svg') left top no-repeat;
  background-size: 24px;
}

/** バッジ */
.user-wrap .name-badge {
  position: absolute;
  top: 0;
  right: 0;
  width: 2.5rem;
}


/** トーク 50px */
.talk-wrap {
  border-left: solid 2px rgba(255, 255, 255, 0.5);
  width: 50px;
  position: relative;
}

.talk-wrap .talk-link {
  display: block;
  height: 100%;
  width: 100%;
  background: url('@/assets/icons/speech_balloon_white.svg') center center no-repeat;
  cursor: pointer;
}

.talk-wrap .talk-link.disabled {
  background: url('@/assets/icons/speech_balloon_gray.svg') center center no-repeat;
  cursor: unset;
}

/** バッジ */
.talk-wrap .talk-badge {
  position: absolute;
  top: 0;
  right: 0;
  width: 2.5rem;
}

.default-wrap {
  height: 100%;
}
</style>